import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { SearchDiscountsParams } from './useSearchDiscounts';

/**
 * Query keys for discounts API calls
 * All keys include servicesProviderId to ensure proper cache isolation between accounts
 *
 * To invalidate ALL discounts queries, use: queries.discounts._def
 */
export const discounts = createQueryKeys('discounts', {
	details: (servicesProviderId: string, id: string) => ({
		queryKey: [servicesProviderId, id],
	}),
	list: (servicesProviderId: string, params?: SearchDiscountsParams) => ({
		queryKey: [servicesProviderId, params],
	}),
	applicableProducts: (servicesProviderId: string) => ({
		queryKey: [servicesProviderId],
	}),
});
